import { Injectable } from '@angular/core';
import { AbstractCrudService } from '../../shared/abstract-crud.service';
import { Favorite } from './favorite.model';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { BehaviorSubject } from 'rxjs';
import { WebsocketMessage } from '../../shared/websocket/websocketMessage';
import { WebsocketService } from '../../shared/websocket/websocket.service';

/**®
 * CRUD service for manipulating favorites
 */
@Injectable()
export class FavoriteService extends AbstractCrudService<Favorite> {
  /**
   * Websocket message stream
   * @type {BehaviorSubject<WebsocketMessage>}
   */
  private websocketMessage = new BehaviorSubject<WebsocketMessage>(new WebsocketMessage());
  /**
   * Observable for new websocket messages
   * @type {Observable<WebsocketMessage>}
   */
  public newWebsocketMessage$ = this.websocketMessage.asObservable();
  /**
   * URL for current model, override url from superclass
   * @type {string}
   */
  protected url = environment.regoApiURL + 'favorites';

  /**
   * Default constructor
   * @param {HttpClient} http
   * @param {WebsocketService} websocket
   */
  constructor(http: HttpClient, private websocket: WebsocketService) {
    super(http);
    this.websocket.newWebsocketMessage$.subscribe(data => {
      if (data.target === 'favorite') {
        this.websocketMessage.next(data);
      }
    });
  }

}
